module.exports = __webpack_public_path__ + "static/espresso_lungo_americano-f2740dfb7497ceb971d02967d16d121e.png";